<template>
  <div v-if="slide" class="assistant-component">
    <div v-if="slide.img" class="assistant-img">
      <img :src="slide.img" :draggable="false" />
    </div>
    <h2 v-if="sizeText==='medium'">
      {{ slide.title }}
    </h2>
    <h1 v-else>
      {{ slide.title }}
    </h1>
    <p v-if="slide.subtitle">
      {{ slide.subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    slide: { type: Object, default: () => ({}) },
    sizeText: { type: String, default: () => "medium" },
  },
};
</script>

<style lang="scss" scoped>
$margin-horizontal: 20px;

.assistant-component {
  margin: 0 auto;
  width: 100%;
  max-width: $page-max-width;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  @media screen and (max-height: 550px) {
    margin-bottom: 75px;
  }

  .assistant-img {
    margin: 5% $margin-horizontal;
    border-radius: 50%;
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $primary-transparent-radiant;
    margin-top: 50px;

    img {
      width: 60%;
    }
  }

  h2 {
    margin: 10px $margin-horizontal;
  }

  p {
    flex: 1;
    margin: 10px $margin-horizontal;
  }
}
</style>
